import React from 'react';
import type { ComponentContentSchema } from '@vibesites/runtime';
// @ts-ignore
import { useContentToken, EditableToken } from '@vibesites/runtime/react';
import { VibesitesImage } from '@vibesites/ui-primitives';
import { SearchAutocomplete } from './SearchAutocomplete';

export function HomeHero() {
  const title = useContentToken('hero.title');
  const subtitle = useContentToken('hero.subtitle');
  const searchPlaceholder = useContentToken('hero.search_placeholder');
  const ctaText = useContentToken('hero.cta_text');
  const bgImage = useContentToken('hero.background_image');

  return (
    <div className="case-hero">
      <div className="case-hero-bg">
        <EditableToken path="hero.background_image" type="image" label="Background Image" defaultValue={contentSchema.tokens['hero.background_image'].defaultValue} as="div">
          <VibesitesImage url={bgImage} alt="" priority sizes="100vw" />
        </EditableToken>
      </div>
      <div className="case-hero-content">
        <EditableToken path="hero.title" type="text" label="Title" defaultValue={contentSchema.tokens['hero.title'].defaultValue} as="h1">
          {title}
        </EditableToken>
        <EditableToken path="hero.subtitle" type="text" label="Subtitle" defaultValue={contentSchema.tokens['hero.subtitle'].defaultValue} as="p">
          {subtitle}
        </EditableToken>
        {/* Hidden EditableToken wrappers for prop-based tokens — sidebar & inline editor support */}
        <span aria-hidden="true" style={{ position: 'absolute', width: 1, height: 1, padding: 0, margin: -1, overflow: 'hidden', clip: 'rect(0,0,0,0)', whiteSpace: 'nowrap', borderWidth: 0 }}>
          <EditableToken path="hero.search_placeholder" type="text" label="Search Placeholder" defaultValue={contentSchema.tokens['hero.search_placeholder'].defaultValue} as="span">
            {searchPlaceholder}
          </EditableToken>
          <EditableToken path="hero.cta_text" type="text" label="Search Button Text" defaultValue={contentSchema.tokens['hero.cta_text'].defaultValue} as="span">
            {ctaText}
          </EditableToken>
        </span>
        <SearchAutocomplete
          variant="hero"
          placeholder={searchPlaceholder}
          buttonText={ctaText}
        />
      </div>
    </div>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'Hero',
  displayName: 'Home Hero',
  tokens: {
    'hero.title': {
      label: 'Title',
      type: 'text',
      defaultValue: 'Find Your Home',
    },
    'hero.subtitle': {
      label: 'Subtitle',
      type: 'text',
      defaultValue: 'With over 40 years of property management experience and over 30,000 units, Case & Associates has a home for you.',
    },
    'hero.search_placeholder': {
      label: 'Search Placeholder',
      type: 'text',
      defaultValue: 'Search by Community, City, State or Zip',
    },
    'hero.cta_text': {
      label: 'Search Button Text',
      type: 'text',
      defaultValue: 'Find a home',
    },
    'hero.background_image': {
      label: 'Background Image',
      type: 'image',
      defaultValue: 'https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfd5d-9a05-729b-9e8b-90e7e8252f66.webp',
    },
  },
};

(HomeHero as unknown as { contentSchema: ComponentContentSchema }).contentSchema = contentSchema;

export default HomeHero;
